import { ArrowUpIcon, AttachmentIcon, QuestionIcon } from "@chakra-ui/icons";
import {
	Box,
	VStack,
	Image,
	Input,
	InputGroup,
	InputRightElement,
	InputLeftElement,
	IconButton,
	Text,
	UnorderedList,
	ListItem,
	Textarea,
	Flex,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import logoimage from "../../assets/logo/logoImg.png";
import pdfImage from "../../assets/waveflowmain/pdfIcon.png";
import { WordByWordParagraph } from "../personalAssistance/Wordplay";
import { CloseIcon } from "@chakra-ui/icons";
import axios from "axios";
import { chatbotAnsPost, workflowApi } from "../../allApi/api";
import DotLoader from "../chatbot/chatLoader/ChatLoader";
import { decryptResponse } from "../../allApi/interceptorsApiCall.js";
import chatbot_agentPhoto from "../../assets/waveflowmain/chatbot_agentPhoto.png";
import apiClient from "../../allApi/interceptorsApiCall";
import { commonStyle } from "../../styles/commonStyle";
import SkeletonChat from "../../components/loader/skeletonLoader/SkeletonChat";
import { useCustomTost } from "../../utiils/useCustomTost";
import MarkdownRenderer from "../../components/stringtomarkdown/Stringtomarkdown";

function PlayComp({ sessionId }) {
	const [allChatData, setAllChatData] = useState([]);
	const [queChat, setQueChat] = useState("");
	const [submitBtn, setSubmitBtn] = useState(false);
	const [submitFormStatus, setSubmitFormStatus] = useState(false);
	const [files, setFiles] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [uploadProgress, setUploadProgress] = useState(0);
	const toast = useCustomTost();
	const [uploadedFiles, setUploadedFiles] = useState([]);

	const waveflowRef = useRef();

	const detectBackendLLMError = (answer = "") => {
		if (!answer) return false;

		const text = answer.toLowerCase();

		const patterns = [
			"error code:",
			"unsupported parameter",
			"invalid_request_error",
			"max_tokens",
			"use 'max_completion_tokens'",
			"unexpected error",
		];

		return patterns.some((p) => text.includes(p));
	};

	// const chatApiCall = async (question, index) => {
	//   const formData = new FormData();
	//   // files.forEach((file) => {
	//   //   formData.append("files", file);
	//   // });
	//   // files.forEach((file) => {
	//   //   formData.append("files", file);
	//   // });
	//   formData.append("query", question);
	//   formData.append("session_id", sessionId);

	//   if (uploadedFiles && uploadedFiles?.length > 0) {
	//     formData.append("filenames", JSON.stringify(uploadedFiles));
	//   }

	//   try {
	//     const res = await apiClient.post("/workflow-run-chat-pdf", formData, {
	//       headers: {
	//         "Content-Type": "multipart/form-data",
	//       },
	//     });

	//     const answer = res?.data?.final_answer;

	//     // Check if the answer contains the specific OpenAI error signature
	//     if (
	//       (answer.includes("Error code: 400") || answer.includes("Unsupported parameter"))
	//     ) {
	//         // Manually throw an error to jump to the catch block
	//         throw new Error("The model is not compatible. Please check backend configuration.");
	//     }

	//     setAllChatData((prevData) =>
	//       prevData.map((item, i) =>
	//         i === index ? { ...item, ans: answer, loading: false } : item
	//       )
	//     );
	//   } catch (error) {
	//     setAllChatData((prevData) =>
	//       prevData.map((item, i) =>
	//         i === index ? { ...item, loading: false } : item
	//       )
	//     );
	//   }
	// };


	// const chatApiCall = async (question, index) => {
	// 	const formData = new FormData();
	// 	formData.append("query", question);
	// 	formData.append("session_id", sessionId);

	// 	if (uploadedFiles?.length > 0) {
	// 		formData.append("filenames", JSON.stringify(uploadedFiles));
	// 	}

	// 	try {
	// 		const res = await apiClient.post("/workflow-run-chat-pdf", formData, {
	// 			headers: { "Content-Type": "multipart/form-data" },
	// 		});

	// 		const answer = res?.data?.final_answer ?? "";

	// 		// --- FRONTEND ERROR HANDLING ---
	// 		if (detectBackendLLMError(answer)) {
	// 			setAllChatData((prev) =>
	// 				prev.map((item, i) =>
	// 					i === index
	// 						? {
	// 								...item,
	// 								ans: "❗ Model error: The current model does not support this request.",
	// 								loading: false,
	// 						  }
	// 						: item
	// 				)
	// 			);
	// 			return;
	// 		}

	// 		// NORMAL SUCCESS
	// 		setAllChatData((prev) =>
	// 			prev.map((item, i) =>
	// 				i === index ? { ...item, ans: answer, loading: false } : item
	// 			)
	// 		);
	// 	} catch (e) {
	// 		// Network/axios errors
	// 		setAllChatData((prev) =>
	// 			prev.map((item, i) =>
	// 				i === index
	// 					? { ...item, ans: "❗ Error calling backend.", loading: false }
	// 					: item
	// 			)
	// 		);
	// 	}
	// };


	const processBackendResponse = (answer = "") => {
		if (!answer) return { isError: false, text: "" };
	
		const textToCheck = answer.toLowerCase();
	
		// 1. Check for Quota/Rate Limit (429)
		if (
		  textToCheck.includes("'code': 429") ||
		  textToCheck.includes('"code": 429') ||
		  textToCheck.includes("error code: 429") ||
		  textToCheck.includes("Error code: 429") ||
		  textToCheck.includes("resource_exhausted")
		) {
		  return {
			isError: true,
			text: "⚠️ You exceeded your current quota. Please check your plan and billing details.",
		  };
		}
	
		// 2. Check for Bad Request / Model Not Available (400)
		if (
		  textToCheck.includes("'code': 400") ||
		  textToCheck.includes('"code": 400') ||
		  textToCheck.includes("error code: 400") ||
		  textToCheck.includes("Error code: 400")
		) {
		  return {
			isError: true,
			text: "⚠️ Invalid Request: The selected model is currently not available or the request was malformed.",
		  };
		}
	
		// 3. Check for other General LLM Errors
		const genericErrorPatterns = [
		  "unsupported parameter",
		  "invalid_request_error",
		  "max_tokens",
		  "use 'max_completion_tokens'",
		  "unexpected error",
		  "error code:", // Catch-all for other codes like 500
		];
	
		if (genericErrorPatterns.some((p) => textToCheck.includes(p))) {
		  return {
			isError: true,
			text: "❗ This model does not support chat interactions. Please switch to a supported model.",
		  };
		}
	
		// 4. No Error Detected
		return { isError: false, text: answer };
	  };

	  const chatApiCall = async (question, index) => {
		const formData = new FormData();
		formData.append("query", question);
		formData.append("session_id", sessionId);
	
		if (uploadedFiles?.length > 0) {
		  formData.append("filenames", JSON.stringify(uploadedFiles));
		}
	
		try {
		  const res = await apiClient.post("/workflow-run-chat-pdf", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		  });
	
		  const rawAnswer = decryptResponse(res?.data)?.final_answer ?? "No response from LLM";
		  
		  // Process the answer to check for 429 or other errors
		  const result = processBackendResponse(rawAnswer);
	
		  setAllChatData((prev) =>
			prev.map((item, i) =>
			  i === index
				? {
					...item,
					ans: result.text, // Uses the clean message OR the actual answer
					loading: false,
					isError: result.isError, // Optional: useful if you want to style error messages differently (e.g. red text)
				  }
				: item
			)
		  );
		} catch (e) {
		  // Network/axios errors (e.g. 500, 404 from server)
		  setAllChatData((prev) =>
			prev.map((item, i) =>
			  i === index
				? { ...item, ans: "❗ Error calling backend.", loading: false }
				: item
			)
		  );
		}
	  };  

	// Upload a single file to the server
	const uploadFile = async (file) => {
		const formData = new FormData();
		formData.append("file", file);

		try {
			const response = await apiClient.post("/file", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
				onUploadProgress: (progressEvent) => {
					const percentCompleted = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);
					setUploadProgress(percentCompleted);
				},
			});

			const decryptedData = decryptResponse(response.data);

			if (decryptedData?.status === "uploaded") {
			  setUploadedFiles((prev) => [...prev, decryptedData.filename]);
			  return true;
			}

			return false;
		} catch (error) {
			console.error("Error uploading file", error);
			toast(
				"Error",
				error?.response?.data?.error || `Failed to upload ${file.name}`,
				"error"
			);
			return false;
		} finally {
			setUploadProgress(0);
		}
	};

	// Handle file selection from input
	const handleFileChange = async (e) => {
		const selectedFiles = Array.from(e.target.files);

		if (!selectedFiles || selectedFiles.length === 0) return;

		const remainingSlots = 10 - files.length;

		if (remainingSlots <= 0) {
			toast("Warning", "Maximum 10 files allowed", "warning");
			return;
		}

		// Only take up to the remaining slots
		const filesToProcess = selectedFiles.slice(0, remainingSlots);

		if (selectedFiles.length > remainingSlots) {
			toast(
				"Warning",
				`Only ${remainingSlots} more files can be added`,
				"warning"
			);
		}

		// Add files to UI first (optimistic update)
		setFiles((prev) => [...prev, ...filesToProcess]);

		// Then upload each file
		setIsLoading(true);

		try {
			for (const file of filesToProcess) {
				const success = await uploadFile(file);

				if (!success) {
					// Remove from UI if upload failed
					setFiles((prev) => prev.filter((f) => f.name !== file.name));
				}
			}
		} catch (error) {
			toast("Error", "Failed to process uploads", "error");
		} finally {
			setIsLoading(false);
			// Reset file input
			e.target.value = "";
		}
	};

	const handleSubmit = () => {
		if (queChat.trim()) {
			setAllChatData([
				...allChatData,
				{ que: queChat, ans: "", loading: true },
			]);
			const textarea = waveflowRef.current;
			textarea.style.height = "45px";
			setSubmitBtn(true);
			setSubmitFormStatus(true);
		}
	};
	const handleQueryWaveFlow = (e) => {
		setQueChat(e.target.value);
		const textarea = waveflowRef.current;
		if (textarea) {
			textarea.style.height = "45px";
			textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`;
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter" || e.keyCode === 13) {
			e.preventDefault();
			handleSubmit();
		}
	};

	useEffect(() => {
		if (submitBtn) {
			const currentIndex = allChatData?.length - 1;
			chatApiCall(queChat, currentIndex);
			setQueChat("");
			setSubmitBtn(false);
		}
	}, [submitBtn]);

	const handleClick = () => {
		document.getElementById("files").click();
	};

	// Remove a file
	// Remove a file
	const handleDeleteFile = (index) => {
		const fileToRemove = files[index];

		// Remove from UI
		setFiles((prev) => prev.filter((_, i) => i !== index));

		// Remove from uploaded files list if present
		if (fileToRemove) {
			setUploadedFiles((prev) =>
				prev.filter((filename) => filename !== fileToRemove.name)
			);
		}
	};

	return (
		<VStack
			justifyContent={"space-between"}
			top={0}
			h={"80vh"}
			w={"100%"}
			m={"auto"}
		>
			<Box
				overflowY="auto"
				sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
				w="100%"
			>
				{allChatData &&
					allChatData.map((ele, index) => (
						<Box key={index} display="flex" flexDirection="column" mb={4}>
							{ele.que && (
								<Box display="flex" alignItems="center">
									<QuestionIcon
										borderRadius={"50%"}
										w={6}
										h={6}
										color="#48BB78"
									/>
									<Box ml={2} bg="gray.200" p={2} borderRadius="md">
										{ele.que}
									</Box>
								</Box>
							)}

							{ele.ans ? (
								<Box display="flex" alignItems="center" mt={2}>
									<Image
										boxSizing={"border-box"}
										w={6}
										src={logoimage}
										alt="Bot Logo"
									/>
									<Box ml={2} bg="gray.200" p={2} borderRadius="md">
										{/* <WordByWordParagraph
                        submitFormStatus={submitFormStatus}
                        paragraph={ele.ans}
                      /> */}
										<MarkdownRenderer content={ele?.ans} />
									</Box>
								</Box>
							) : ele.loading ? (
								<Box ml={8} mt={2}>
									{/* Loading... */}
									<SkeletonChat />
								</Box>
							) : null}
						</Box>
					))}
			</Box>

			<Box w={"100%"} boxSizing={"border-box"} bg={"#fff"}>
				<Box alignItems="flex-start" mt={2} w={"100%"}>
					{files?.length > 0 && <Text fontWeight="bold">Uploaded Files:</Text>}
					{files?.length > 0 && (
						<UnorderedList
							h={"100px"}
							styleType="disc"
							ml={4}
							overflowY="auto"
							sx={{ ...commonStyle.sx, scrollBehavior: "smooth" }}
						>
							{files.map((file, idx) => (
								<ListItem
									textAlign="left"
									key={idx}
									display="flex"
									alignItems="center"
									justifyContent="space-between"
								>
									<Box display="flex" alignItems="center">
										<Image
											src={pdfImage}
											alt="PDF Icon"
											boxSize={"20px"}
											mr={2}
										/>
										{file.name}
										{uploadedFiles.includes(file.name) && (
											<Text fontSize="xs" ml={2} color="green.500">
												(Uploaded)
											</Text>
										)}
									</Box>
									<IconButton
										icon={<CloseIcon />}
										size="sm"
										aria-label="Delete file"
										onClick={() => handleDeleteFile(idx)}
									/>
								</ListItem>
							))}
						</UnorderedList>
					)}
				</Box>
				{uploadProgress > 0 && (
					<Box mb={2}>
						<Text fontSize="sm">Uploading: {uploadProgress}%</Text>
						<Box bg="gray.200" h="6px" borderRadius="md" overflow="hidden">
							<Box
								bg="#6866D3"
								h="100%"
								width={`${uploadProgress}%`}
								transition="width 0.3s"
							/>
						</Box>
					</Box>
				)}

				<Flex
					border="1px solid lightgray"
					borderRadius="10px"
					bg="white"
					px={2}
					py={1}
					alignItems="flex-end"
					w="100%"
				>
					{/* Attachment Icon */}
					<Box>
						<input
							type="file"
							id="files"
							accept=".pdf, .doc, .docx, .txt, .csv, .json, .ipynb, .py"
							multiple
							onChange={handleFileChange}
							style={{ display: "none" }}
						/>
						<IconButton
							icon={<AttachmentIcon />}
							size="sm"
							aria-label="Attach"
							onClick={() => document.getElementById("files").click()}
							isDisabled={isLoading}
							variant="ghost"
							mb={1}
						/>
					</Box>

					{/* Textarea */}
					<Textarea
						ref={waveflowRef}
						value={queChat}
						onChange={handleQueryWaveFlow}
						placeholder="What would you like to know?"
						focusBorderColor="transparent"
						_focus={{ boxShadow: "none" }}
						border="none"
						resize="none"
						minH="40px"
						maxH="150px"
						overflowY="auto"
						lineHeight="1.5"
						onKeyDown={handleKeyDown}
						mx={2}
						flex={1}
					/>

					{/* Send Button */}
					<Box>
						<IconButton
							icon={<ArrowUpIcon />}
							aria-label="Send"
							size="sm"
							bg="#6866D3"
							color="white"
							borderRadius="full"
							_hover={{ bg: "#5755c9" }}
							onClick={handleSubmit}
							mb={1}
						/>
					</Box>
				</Flex>
			</Box>
		</VStack>
	);
}

export default PlayComp;
